<template>
  <v-app :class="isPrintMode ? 'print-mode': ''">
    <!-- <v-progress-linear
      :active="loading"
      indeterminate
      absolute
      color="deep-orange"
    /> -->
    <s-ajax-bar />
    <template v-if="showTopToolbar">
      <component
        :is="toolbar"
        class="app-toolbar"
      />
      <!-- <s-toolbar v-if="$config.isWeb" />
      <s-app-toolbar v-if="$config.isApp" />
      <s-pwa-toolbar v-if="$config.isPwa" /> -->
    </template>
    <s-error-dialog />
    <s-http-error />
    <v-main>
      <v-slide-x-transition hide-on-leave>
        <router-view />
      </v-slide-x-transition>
    </v-main>

    <v-snackbar
      v-model="snackbar"
      bottom
    >
      {{ $store.state.global.snackbarMsg }}
    </v-snackbar>

    <app-snackbar ref="appSnackbar" />
    <app-dialog ref="appDialog" />
  </v-app>
</template>

<script>
import SAjaxBar from './components/SAjaxBar'
import SErrorDialog from './components/SErrorDialog'
import SHttpError from './components/SHttpError'
import AppSnackbar from './appUI/AppSnackbar.vue'
import AppDialog from './appUI/AppDialog.vue'
import constant from './constant/constant'
import { getCurrentLanguage } from '@/utils/govappUtil'
import storageUtil from '@/utils/storageUtil'

export default {
  name: 'App',
  components: {
    SAjaxBar,
    SErrorDialog,
    SHttpError,
    AppSnackbar,
    AppDialog
  },
  provide () {
    return {
      appUI: this.$refs // { appSnackBar, appDialog }
    }
  },
  data: function () {
    return {
      // showToolbar: false,
      // showPwaToolbar: true,
      snackbarMessage: null
    }
  },
  computed: {
    snackbar: {
      get () {
        return this.$store.state.global.snackbar
      },
      set (value) {
        this.$store.commit('global/setSnackbar', value)
      }
    },
    isPrintMode () {
      return this.$store.state.global.isPrintMode
    },
    showTopToolbar () {
      let layout = this.$route.meta.layout
      if (layout && layout.includes(constant.NO_TOOLBAR)) {
        return false
      } else {
        return true
      }
    },
    toolbar () {
      if (this.$config.isGaWeb) {
        return () => ({
          component: import('./components/SGaToolbar.vue')
        })
      } else if (this.$config.isApp) {
        return () => ({
          component: import('./components/SAppToolbar.vue')
        })
      } else if (this.$config.isPwa) {
        return () => ({
          component: import('./components/SPwaToolbar.vue')
        })
      } else {
        return () => ({
          component: import('./components/SToolbar.vue')
        })
      }
    }
  },
  created () {
    if (this.$config.isApp) {
      let lang = getCurrentLanguage()
      if (lang.indexOf('zh') >= 0) {
        storageUtil.setStorage('g2e-lang', 'zh-hant')
        this.$i18n.locale = 'zh'
        this.$vuetify.lang.current = 'zhHant'
      } else {
        storageUtil.setStorage('g2e-lang', 'pt')
        this.$i18n.locale = 'pt'
        this.$vuetify.lang.current = 'pt'
      }
    }
  }
}
</script>
